module.exports = __webpack_public_path__ + "img/Omnisend.224885ac.svg";